import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('address')
export class Address {
  @JsonProperty('street')
  public street: string = '';
  @JsonProperty('houseNumber')
  public houseNumber: string = '';
  @JsonProperty('houseNumberAddition')
  public houseNumberAddition: string = '';
  @JsonProperty('postCode')
  public postCode: string = '';
  @JsonProperty('city')
  public city: string = '';
  @JsonProperty('country')
  public country: string = '';

  constructor(
    street?: string,
    houseNumber?: string,
    houseNumberAddition?: string,
    postCode?: string,
    city?: string,
    country?: string
  ) {
    if (street != null) {
      this.street = street;
    }
    if (houseNumber != null) {
      this.houseNumber = houseNumber;
    }
    if (houseNumberAddition != null) {
      this.houseNumberAddition = houseNumberAddition;
    }
    if (postCode != null) {
      this.postCode = postCode;
    }
    if (city != null) {
      this.city = city;
    }
    if (country != null) {
      this.country = country;
    }
  }
}
